import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';
import { PRODUCT } from '@/user/products/product.type';
import { useUserProducts } from '@/user/products/use-user-products';

export const useEditorsChoiceAccess = () => {
  const { hasRequiredProduct } = useUserProducts();
  const { hasRequiredPermission } = useUserPermissions();

  const hasSpotlightProduct = hasRequiredProduct(PRODUCT.SPOTLIGHT);

  return {
    canSeeEditorsChoice: hasSpotlightProduct,
    canModifyEditorsChoice:
      hasRequiredPermission(PERMISSION.TOGGLE_ORGANIZATION_EDITORS_CHOICE) &&
      hasSpotlightProduct,
  };
};
